import React, { useRef } from "react";
import Printable from "../A4";

export default function VoucherExample() {
  const printRef = useRef();

  const triggerPrint = () => {
    printRef.current?.handlePrint?.();
  };

  return (
    <div>
      <div style={{ margin: 20 }}>
        <div className="d-flex justify-content-end w-100">
          <button onClick={triggerPrint} style={styles.printBtn}>
            Print Report
          </button>
        </div>
        <Printable
          ref={printRef}
          documentTitle="Journal Voucher"
          companyName="SGL Marketing Demo"
        >
          <div style={{ padding: 40, fontFamily: "Arial, sans-serif" }}>
            <h2 style={{ textAlign: "center", color: "black" }}>
              JOURNAL VOUCHER
            </h2>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 20,
              }}
            >
              <div>
                <strong>SGL Marketing Demo</strong>
              </div>
              <div style={{ textAlign: "right" }}>
                <div>
                  <strong>REF. NO.:</strong> JV 1512001
                </div>
                <div>
                  <strong>DATE:</strong> 31/12/2015
                </div>
              </div>
            </div>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: 20,
              }}
            >
              <thead>
                <tr>
                  <th style={styles.th}>A/C NO.</th>
                  <th style={styles.th}>A/C DESCRIPTION</th>
                  <th style={styles.th}>DESCRIPTION</th>
                  <th style={styles.th}>DEBIT</th>
                  <th style={styles.th}>CREDIT</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={styles.td}>9030/0001</td>
                  <td style={styles.td}>BANK CHARGES</td>
                  <td style={styles.td}>BANK CHARGES HALF YEARLY</td>
                  <td style={styles.td}>10.60</td>
                  <td style={styles.td}></td>
                </tr>
                <tr>
                  <td style={styles.td}>3010/0001</td>
                  <td style={styles.td}>BANK - MBB A/C 51459360089</td>
                  <td style={styles.td}>BANK CHARGES HALF YEARLY</td>
                  <td style={styles.td}></td>
                  <td style={styles.td}>10.60</td>
                </tr>
              </tbody>
            </table>

            <div
              style={{
                textAlign: "right",
                fontWeight: "bold",
                marginBottom: 40,
              }}
            >
              TOTAL AMOUNT: 10.60
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 60,
              }}
            >
              <div>APPROVED BY:</div>
              <div
                style={{ borderBottom: "1px solid #000", width: "250px" }}
              ></div>
            </div>
          </div>
        </Printable>
      </div>
    </div>
  );
}

const styles = {
  printBtn: {
    padding: "5px 10px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "2px",
    cursor: "pointer",
    marginRight: "40px",
  },
  th: {
    border: "1px solid #000",
    padding: "8px",
    textAlign: "left",
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
  },
  td: {
    border: "1px solid #000",
    padding: "8px",
    textAlign: "left",
  },
};
